import React from 'react'
import Button from '@mui/material/Button'
import { FxIcon } from '../icon/FxIcon'
import { FxButtonProps } from './FxButton.props'

/**
 *
 * @param label
 * @param className
 * @param variant
 * @param color
 * @param size
 * @param startIcon
 * @param endIcon
 * @param disabled
 * @param onClick
 * @param fullWidth
 * @param style
 * @constructor
 */
export const FxButton = ({
  label,
  className,
  variant,
  color,
  size,
  startIcon,
  endIcon,
  disabled = false,
  onClick,
  action,
  style,
  fullWidth = false,
  sx,
  startIconClassName,
  endIconClassName
}: FxButtonProps) => {
  const startIconNode: any = startIcon ? <FxIcon icon={startIcon} className={startIconClassName} /> : <></>
  const endIconNode: any = endIcon ? <FxIcon icon={endIcon} className={endIconClassName} /> : <></>
  return (
    <Button
      style={style}
      sx={sx}
      variant={variant}
      className={`fx-button ${className}`}
      size={size}
      color={color}
      disabled={disabled}
      onClick={onClick || action}
      startIcon={startIconNode}
      endIcon={endIconNode}
      fullWidth={fullWidth}>
      {label && label}
    </Button>
  )
}
